import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(Boolean(localStorage.getItem("arclyst_token")));
  const store = useCallback((data) => { localStorage.setItem("arclyst_token", data.token); localStorage.setItem("arclyst_user", JSON.stringify(data.user)); setUser(data.user); }, []);
  const login = useCallback(async (email, password) => { const { data } = await api.post("/auth/login", { email, password }); store(data); }, [store]);
  const register = useCallback(async (payload) => { const { data } = await api.post("/auth/register", payload); store(data); }, [store]);
  const refreshUser = useCallback(async () => { const { data } = await api.get("/auth/me"); localStorage.setItem("arclyst_user", JSON.stringify(data)); setUser(data); return data; }, []);
  const logout = useCallback(() => { localStorage.removeItem("arclyst_token"); localStorage.removeItem("arclyst_user"); setUser(null); setLoading(false); }, []);
  useEffect(() => {
    if (!localStorage.getItem("arclyst_token")) return;
    api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => logout()).finally(() => setLoading(false));
  }, [logout]);
  const value = useMemo(() => ({ user, loading, login, register, refreshUser, logout }), [user, loading, login, register, refreshUser, logout]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}